'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';
import '../../libs/geoxml3.js';
import 'ngmap';
import MarkerClusterer from 'marker-clusterer-plus';
window.MarkerClusterer = MarkerClusterer;

EwSiteApp.requires.push('ngMap');

EwSiteApp.controller('FaultMapCtrl', ['$scope', '$http', '$interval', '$sce', 'NgMap', function($scope, $http, $interval, $sce, NgMap){
	let gMap;
	$scope.timestamp;
	$scope.renewData = false;
	$scope.importantMessageShow = true;
	$scope.alertMessage = mapData.notifications.notification_red_text;
	$scope.warningMessage = mapData.notifications.notification_orange_text;
	$scope.newAlertMessage = mapData.notifications.notification_alert_text;
	$scope.alertMessageShow = !!mapData.notifications.notification_red_on;
	$scope.warningMessageShow = !!mapData.notifications.notification_orange_on;
	$scope.newAlertMessageShow = !!mapData.notifications.notification_alert_on;
	const dataUrl = mapData.dataUrl;
	const statusUrl = mapData.statusUrl;
	const statUrl = mapData.statUrl;
	const statusCheckInterval = mapData.statusCheckInterval * 1000;
	
	let statusInterval;
	let markerClusterer;
	let markers = [];
	let polygons = [];
	
	const zoomLevel = 11;
	let placeMarker;
	let placeInput;
	const markerZoom = 14;
	
	$scope.loader = false;
	$scope.placeStatus = false;

    $scope.info = {
        show: window.innerWidth > 768,
        data: undefined,
        loading: false,
        statistics: undefined
    };

	//changed image path
	MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = theme_path + 'img/faultmap/';

	// ESOEW4-1483 r2: du signalai — „Planiniai" (fp) ir „Sutrikimai" (fn).
	// „Sutrikimai" apjungia buvusius N/K/G (žr. getDataParams).
	$scope.filter = {
		fn: true,
		fp: true
	};
	
	$scope.clearPlace = function(){
		if(typeof(placeMarker) !== 'undefined'){
			placeMarker.setMap(null);
			placeMarker = undefined;
		}
		if(!arguments[0] && typeof(placeInput) !== 'undefined'){
			placeInput.value = '';
		}
		$scope.placeStatus = false;
	};

	// Panelė (.side-info-holder) tilpsta tarp header (.map-holder__widgets) ir
	// footer (.filter-block) be fiksuotų px: matuojam realius jų aukščius ir
	// paduodam į CSS kintamuosius --fm-side-top / --fm-side-bottom. Perskaičiuojam
	// prie resize ir kai header/footer keičia aukštį (ResizeObserver).
	function syncSideInfoBounds() {
		const holder = document.querySelector('.fault-map-holder');
		if (!holder) return;
		const header = holder.querySelector('.map-holder__widgets');
		const footer = holder.querySelector(':scope > .filter-block');
		const gap = 12; // tarpas nuo header/footer iki panelės
		const hr = holder.getBoundingClientRect();
		if (header) {
			holder.style.setProperty('--fm-side-top',
				Math.round(header.getBoundingClientRect().bottom - hr.top + gap) + 'px');
		}
		if (footer) {
			holder.style.setProperty('--fm-side-bottom',
				Math.round(hr.bottom - footer.getBoundingClientRect().top + gap) + 'px');
		}
	}
	window.addEventListener('resize', syncSideInfoBounds);
	if (window.ResizeObserver) {
		const ro = new ResizeObserver(syncSideInfoBounds);
		const roHeader = document.querySelector('.fault-map-holder .map-holder__widgets');
		const roFooter = document.querySelector('.fault-map-holder > .filter-block');
		if (roHeader) ro.observe(roHeader);
		if (roFooter) ro.observe(roFooter);
	}

	NgMap.getMap().then(function(map) {
		gMap = map;
		getData();
		getStatistics();
		syncSideInfoBounds();


		// google place initialization
		function init() {
			placeInput = document.getElementById('locationTextField');
			const places = new google.maps.places.Autocomplete(placeInput, {
				componentRestrictions: {
					country: ["lt"]
				}
			});
			
			const address = document.getElementById("locationWrapper");
			google.maps.event.addListener(places, 'place_changed', function () {
				const place = places.getPlace();
				const lat = place.geometry.location.lat();
				const lng = place.geometry.location.lng();
				const latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
				$scope.clearPlace(true);
				placeMarker = new google.maps.Marker({
					position: latLng,
					clickable: false
				});
				placeMarker.setMap(gMap);
				gMap.setCenter(latLng);
				gMap.setZoom(markerZoom);
				$scope.placeStatus = true;
				$scope.$apply();
			});
			return address;
		}
const isMobile = window.innerWidth <= 768;
        const myOptions = {
            streetViewControl: false,
            zoomControl: !isMobile,
            fullscreenControl: false,
            addressControl: true,
            zoom: calculateZoom(),
            mapTypeControl: false,
            cameraControl: false,
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }]
                },
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
            ],
            restriction: {
                latLngBounds: {
                    north: 57.447902,
                    south: 51.953324,
                    east: 31.989427,
                    west: 16.780594,
                },
            },
        };
		map.setOptions(myOptions);
		
		const geoXml = new geoXML3.parser({
			map: map,
			suppressInfoWindows: true,
            zoom: false,
		});
		geoXml.parse(theme_path + 'kml/placemark.kml');
		init();

		map.addListener("bounds_changed", () => {
			if (angular.isDefined(markerClusterer)) {
				const bounds = map.getBounds();
				if (map.getZoom() <= zoomLevel) {
					for (const polygon of polygons) {
						polygon.setVisible(false);
						polygon.setMap(null);
					}
					for (const marker of markerClusterer.getMarkers()) {
						if (marker.dynamic && bounds.contains(marker.getPosition())) {
							marker.setVisible(true);
						}
					}
				} else {
					for (const marker of markerClusterer.getMarkers()) {
						if (marker.dynamic && bounds.contains(marker.getPosition())) {
							marker.setVisible(false);
						}
					}
					for (const polygon of polygons) {
						if (bounds.intersects(polygon.getBounds())) {
							polygon.setMap(gMap);
							polygon.setVisible(true);
						} else {
							polygon.setVisible(false);
							polygon.setMap(null);
						}
					}
				}
			}
		});
	});
	
	$scope.filterChange = function(){
		getData();
	};
	
	$scope.updateData = function(){
		$scope.closeInfo();
		getData();
		getStatistics();
	};
	
	function getData(){
		statusStop();
		$scope.loader = true;
		const rq = $http({
			method: 'GET',
			url: dataUrl,
			params: getDataParams()
		});
		rq.then(function(response){
			if(response.data.success){
				$scope.timestamp = response.data.timestamp;
				$scope.renewData = false;
				initMapData(response.data.data);
				statusStart();
			}
			else if(response.data.message){
				console.log(response.data.message);
			}
			$scope.loader = false;
		}, function(){
			$scope.loader = false;
		});
	}
	
	function getStatistics(){
		const rq = $http({
			method: 'GET',
			url: statUrl
		});
		rq.then(function(response){
			if(response.data.success){
				$scope.info.statistics = response.data.data;
			}
			else if(response.data.message){
				console.log(response.data.message);
			}
		}, function(){
			// on communication error
		});
	}
	
	function getDataParams(){
		// „Sutrikimai" filtras (fn) apjungia N (sutrikimai), K (klientų pranešimai) ir G
		// į vieną signalą (ESOEW4-1483 r2). „Planiniai atjungimai" — fp.
		const faults = ($scope.filter.fn) ? 1 : 0;
		return {
			fp: ($scope.filter.fp) ? 1 : 0,
			fn: faults,
			fk: faults,
			fg: faults
		};
	}

    function calculateZoom() {
        const width = window.innerWidth;
        const height = window.innerHeight;

        if (width <= 768) {
            return 6;
        }

        const minDimension = Math.min(width, height);

        if (minDimension < 600) {
            return 6;
        } else if (minDimension < 800) {
            return 7;
        } else if (minDimension < 1000) {
            return 7;
        } else {
            return 8;
        }
    }
	
	// Poligonų (paveiktos zonos) spalvos pagal imps2 status. ESOEW4-1483 r2: raudona
	// panaikinta — registruotas ir vykdomi = oranžinė; tik atstatytas — žalias.
	const STATUS_POLY_HEX = {
		'OUTAGE_REGISTERED': '#FFBB55',
		'RESOURCE_EN_ROUTE': '#FFBB55',
		'RESOURCE_ON_SITE': '#FFBB55',
		'OUTAGE_FIXED': '#34C759'
	};

	// imps2 status -> markerio spalvos raktas. Legacy (tuščias status) -> null.
	// ESOEW4-1483 r2: raudona panaikinta — registruotas ir vykdomi žymimi oranžiniu trikampiu.
	function statusColorKey(status){
		switch(status){
			case 'OUTAGE_REGISTERED':
			case 'RESOURCE_EN_ROUTE':
			case 'RESOURCE_ON_SITE': return 'orange';
			case 'OUTAGE_FIXED': return 'green';
			default: return null;
		}
	}

	// imps2 incidentams (N/K/G su status) spalva pagal status. ESOEW4-1483 r2:
	// „klientų pranešimai" (K) vaizduojami tuo pačiu „sutrikimo" (trikampio) glifu
	// kaip N/G — vienas signalas. Legacy / be status — senoji tipo ikona (K -> N).
	function markerIconFile(d){
		const color = statusColorKey(d.status);
		if(color){
			return 'tri_' + color + '.svg';
		}
		return (d.type === 'K' ? 'N' : d.type) + 'sq.svg';
	}

	// imps2 status gyvavimo ciklas (skubumo tvarka) — stepperio pakopų eilė.
	const STATUS_ORDER = ['OUTAGE_REGISTERED', 'RESOURCE_EN_ROUTE', 'RESOURCE_ON_SITE', 'OUTAGE_FIXED'];

	// status enum -> pakopų būsenos {enum:'done'|'current'|'future'} arba null (P/tuščias -> pill).
	function buildStatusSteps(status){
		const idx = STATUS_ORDER.indexOf(status);
		if (idx < 0) return null;
		const steps = {};
		STATUS_ORDER.forEach(function(key, i){
			steps[key] = (i < idx) ? 'done' : (i === idx ? 'current' : 'future');
		});
		return steps;
	}

	function initMapData(points){
		if (angular.isDefined(markerClusterer)) {
			markerClusterer.clearMarkers();
		}
		for (const polygon of polygons) {
			polygon.setMap(null);
		}
		markers = [];
		polygons = [];
		const currentZoom = gMap.getZoom();
		for (const d of points) {
			let element;
			const latLng = new google.maps.LatLng(parseFloat(d.lat), parseFloat(d.lng));
			if ((d.type == 'P' || d.type == 'N') && typeof(d.area) !== 'undefined' && d.area.length > 0) {
				const polyOptions = {
					paths: d.area,
					strokeColor: "#1976d2",
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: "#1976d2",
					fillOpacity: 0.35,
					pas_id: d.pas_id,
					fault_type: d.type,
				};
				if (d.type == 'N') {
					const polyColor = STATUS_POLY_HEX[d.status] || '#FFBB55';
					polyOptions.strokeColor = polyColor;
					polyOptions.fillColor = polyColor;
				}
				polyOptions.bounds = new google.maps.LatLngBounds();
				for (const g of d.area) {
					for (const ll of g) {
						polyOptions.bounds.extend(new google.maps.LatLng(parseFloat(ll.lat), parseFloat(ll.lng)));
					}
				}
				const poly = new google.maps.Polygon(polyOptions);
				poly.getPosition = function() {
					return new google.maps.LatLng(parseFloat(d.lat), parseFloat(d.lng));
				};
				poly.getBounds = function(){
					return this.bounds;
				};
				google.maps.event.addListener(poly, 'click', function(){
					showPointInfo(d);
				});
				polygons.push(poly);
				
				element = new google.maps.Marker({
					position: latLng,
					clickable: true,
					pas_id: d.pas_id,
					fault_type: d.type,
					dynamic: true,
					icon: {
						url: MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ + markerIconFile(d),
						scaledSize: new google.maps.Size(56, 56),
					}
				});
			} else {
				element = new google.maps.Marker({
					position: latLng,
					clickable: true,
					pas_id: d.pas_id,
					fault_type: d.type,
					dynamic: false,
					icon: {
						url: MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ + markerIconFile(d),
						scaledSize: new google.maps.Size(56, 56),
					}
				});
			}
			google.maps.event.addListener(element, 'click', function(){
				showPointInfo(d);
			});
			markers.push(element);
		}
		
		// Visi klasteriai naudoja tą pačią „zoom" ikoną (index 1 -> styles[0]),
		// nepriklausomai nuo gedimų tipo (K/N/G/P).
		const calc = function(markers) {
			return {text: '', index: 1};
		};
		
		const mcOptions = {
			maxZoom: zoomLevel, // jei daugiau, clusteringas issijungia
			styles: [
				{
					height: 56,
					url: theme_path + 'img/faultmap/zoom.png',
					width: 56,
				},
				{
					height: 56,
					url: theme_path + 'img/faultmap/planned_dc.png',
					width: 56,
				},
				{
					height: 56,
					url: theme_path + 'img/faultmap/fault.png',
					width: 56,
				},
				{
					height: 56,
					url: theme_path + 'img/faultmap/client_fault.png',
					width: 56,
				}
			]
		};

		markerClusterer = new MarkerClusterer(gMap, markers, mcOptions);
		markerClusterer.setCalculator(calc);
		if (gMap.getZoom() != zoomLevel) {
			google.maps.event.trigger(gMap, 'bounds_changed');
		}
	}

	function statusStart(){
		if (angular.isDefined(statusInterval)) return;
		statusInterval = $interval(function(){
			$http({
				method: 'GET',
				url: statusUrl
			}).then(function(response){
				if(response.data.success && response.data.timestamp > $scope.timestamp){
					$scope.renewData = true;
					statusStop();
				}
			}, function(){
				statusStop();
			});
		}, statusCheckInterval);
	}
	
	function statusStop(){
		if(angular.isDefined(statusInterval)){
			$interval.cancel(statusInterval);
            statusInterval = undefined;
		}
	}
	
	function showPointInfo(point){
		$scope.info.show = true;
		$scope.info.loading = true;
		$scope.$apply();
		const params = getDataParams();
		params.pas_id = point.pas_id;
		$http({
			method: 'GET',
			url: mapData.pointUrl,
			params: params
		}).then(function(response){
			$scope.info.loading = false;
			if(response.data.success){
				$scope.info.data = response.data.data;
				if($scope.info.data){
					$scope.info.data.statusSteps = buildStatusSteps($scope.info.data.status);
				}
			}
		}, function(){
			// noop
		});
	}
	
	$scope.closeInfo = function(){
		// X mygtukas — uždaro panelę ir nuima pasirinktą tašką (grįžta „Informacija").
		// ESOEW4-1483 r2: panelė be akordeonų — blokai visada atverti.
		$scope.info.show = false;
		$scope.info.loading = false;
		$scope.info.data = undefined;
	};

    // Meniu (hamburger) mygtukas — atidaro/uždaro šoninę panelę.
    $scope.toogleStat = function(){
        if($scope.info.show){
            $scope.closeInfo();
        }
        else{
            $scope.info.loading = false;
            $scope.info.show = true;
        }
    };

	$scope.hideAlertMessage = function() {
		$scope.alertMessageShow = false;
	};

	$scope.hideWarningMessage = function() {
		$scope.warningMessageShow = false;
	};
	$scope.hideAlertNewMessage = function() {
		$scope.newAlertMessageShow = false;
	};
	
	$scope.explicitlyTrustedHtml = function(text) {
        return $sce.trustAsHtml(text);
	};
	
}]);
